import { useTranslation } from "react-i18next";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { Confirm } from "@/shared/ui";
import {
  designOpenConfirmBuySelector,
  previewedDesignVariantSelector,
  selectedDesignVariantSelector,
  setDesignOpenConfirmBuy,
} from "@/domains/estate/slice";
import useDesignHandlers from "@/domains/estate/hooks/handlers/useDesignHandlers";

function EstateDesignVariantBuyConfirmModalContainer() {
  const { t } = useTranslation("estate");
  const dispatch = useAppDispatch();
  const open = useAppSelector(designOpenConfirmBuySelector);
  const selectedDesignVariant = useAppSelector(selectedDesignVariantSelector);
  const previewedDesignVariant = useAppSelector(previewedDesignVariantSelector);
  const { buyHandler, isBuying } = useDesignHandlers();

  const buyInteriorPropId =
    selectedDesignVariant?.interiorPropId || previewedDesignVariant?.interiorPropId;

  return (
    <Confirm
      open={open}
      title={t("estate.design.confirmBuy.title")}
      onConfirm={() => {
        buyHandler(buyInteriorPropId).then(() => {
          dispatch(setDesignOpenConfirmBuy(false));
        });
      }}
      onCancel={() => {
        dispatch(setDesignOpenConfirmBuy(false));
      }}
      pending={isBuying}
    />
  );
}

export default EstateDesignVariantBuyConfirmModalContainer;
